export default function NotFoundPage() {
  return <div>Page Cannot be found</div>;
}
